/* 收藏夹高阶弹框 */
<template>
  <div class="favorites-dialog">
    <z-addFavorites
      @search="searchHandle"
      @favoritesAdd="favoritesAdd"
      @created="createdHandle"
      :ossUrl="ossPrefix"
      :lists="list"
      :imgFile="imgFile"
      :txt="title"
      :display="model"
      @close="closeDialog"
      title="添加到收藏夹"
      width="900"
    ></z-addFavorites>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      model: false,
      list: [],
      imgFile: {},
      title: "",
      uploadParam: "",
      type: 1,
      filter: {
        resourceId: 0,
        type: 1,
        keyword: ""
      }
    };
  },
  methods: {
    async open(id = -1, type = "product", infos) {
      this.setType(type);
      this.filter = {
        resourceId: id,
        type: this.type,
        keyword: ""
      };
      if (type === "product") {
        this.imgFile = infos.imgFile;
        this.title = infos.title || "";
      }
      if (type === "inspiration") {
        this.imgFile = infos.imgFile;
        this.title = infos.title;
        this.uploadParam = infos;
      }
      if (type === "uploadInspiration") {
        this.title = infos.inspiration.describe || infos.inspiration.inspirationFile.name;
        this.imgFile = infos.inspiration.inspirationFile;
        this.uploadParam = infos;
      }
      if (type === "uploadProduct") {
        this.title = infos.name;
        this.imgFile = infos.coverFile;
        this.uploadParam = infos;
      }

      this.list = await this.getAjaxList(
        this,
        this.filter.resourceId,
        this.filter.type,
        this.filter.keyword
      );
      this.model = true;
    },
    /* 设置不同的type */
    setType(type) {
      switch (type) {
        case "product":
          this.type = 1;
          break;
        case "plan":
          this.type = 2;
          break;
        case "inspiration":
          this.type = 3;
          break;
        case "uploadProduct":
          this.type = 4;
          break;
        case "uploadInspiration":
          this.type = 5;
          break;
        default:
          this.type = 1;
          break;
      }
    },
    closeDialog() {
      this.model = false;
    },
    getAjaxList(app, resourceId, type, keyword = null) {
      return new Promise((resovle, reject) => {
        let ajax = "";
        if (resourceId > 0) {
          ajax = `/designer_api/collection/my_favorites?resourceId=${resourceId}&type=${type}&keyword=${keyword}`;
        } else {
          ajax = `/designer_api/collection/my_favorites?type=${type}&keyword=${keyword}`;
        }
        axios
          .get(ajax)
          .then(res => {
            resovle(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    async getLists() {
      this.list = await this.getAjaxList(
        this,
        this.filter.resourceId,
        this.filter.type,
        this.filter.keyword
      );
    },

    createdHandle(keyword) {
      this.createList(this, keyword);
    },

    /* 创建或者搜索 */
    async searchHandle(keyword) {
      this.filter.keyword = keyword;
      this.getLists();
      if (!this.list || this.list.length === 0) {
        /* 调用创建 */
        this.createList(this, keyword);
      }
    },

    /* 创建收藏夹 */
    async createList(app, name) {
      await axios.post(`/designer_api/collection/favorites`, {
        name: name
      });
      app.$Message.success("创建成功");
      this.getLists();
    },

    /* 添加 灵感源和产品 到收藏夹 */
    favoritesAdd(ids, target) {
      if (this.type === 5) {
        this.addUploadInspiration(ids, target);
      } else if (this.type === 4) {
        this.addOlnyProducts(ids, target);
      } else {
        this.addProductsFavorites(ids, target);
      }
    },

    /* 添加 灵感源和产品 到收藏夹 */
    addProductsFavorites(ids, target) {
      const app = this;
      axios
        .post(`/designer_api/collection/into_favorites`, {
          favoriteIds: ids,
          resourceId: this.filter.resourceId,
          type: this.filter.type
        })
        .then(res => {
          let txt = "";
          if (target === "cencel") {
            txt = "取消收藏";
          } else {
            txt = "收藏成功";
          }
          app.$Message.success(txt);
          // this.getLists();
          this.handleSuccess();
        });
    },

    /* 添加 灵感源到收藏夹*/
    addUploadInspiration(ids, target) {
      const app = this;
      axios
        .post(`/designer_api/inspirations/upload`, {
          favoriteIds: ids,
          coverFile: this.uploadParam.inspiration.inspirationFile,
          name: this.uploadParam.inspiration.inspirationFile.name,
          inspiration: {
            labels: this.uploadParam.inspiration.labels,
            describe: this.uploadParam.inspiration.describe,
            inspirationFile: this.uploadParam.inspiration.inspirationFile
          }
        })
        .then(res => {
          let txt = "";
          if (target === "cencel") {
            txt = "取消收藏";
          } else {
            txt = "收藏成功";
          }
          app.$Message.success(txt);
          // this.getLists();
          this.handleSuccess();
        });
    },

    /* 单品收藏夹 */
    addOlnyProducts(ids, target) {
      const app = this;
      axios
        .post(`/designer_api/products/upload`, {
          favoriteIds: ids,
          coverFile: this.uploadParam.coverFile,
          name: this.uploadParam.name,
          size: this.uploadParam.size,
          material: this.uploadParam.material
        })
        .then(res => {
          let txt = "";
          if (target === "cencel") {
            txt = "取消收藏";
          } else {
            txt = "收藏成功";
          }
          app.$Message.success(txt);
          // this.getLists();
          this.handleSuccess();
        });
    },
    handleSuccess() {
      this.$emit("success", this.filter.resourceId);
    }
  }
};
</script>
